<template>
  <div>
    <!-- tab menus -->
    <div class="tabs is-centered is-boxed">
      <ul>
        <li
          @click="tabChanged(tab)"
          :class="{'is-active': tab === selectedType}"
          :key="tab"
          v-for="tab in tabs"
        >
          <a>{{tab}}</a>
        </li>
      </ul>
    </div>

    <div :key="weight.id" v-for="weight in filteredWeights">
      <b-tooltip
        :label="`${weight.sport} - ${weight.name} - ${weight.feed_weight}`"
        size="is-small"
        type="is-dark"
        style="width:100%;"
      >
        <input
          :class="`slider-${weight.slug}`"
          type="range"
          min="0"
          max="60"
          v-model="weight.feed_weight"
          class="slider"
          id="myRange"
          @change="weightChanged(weight)"
        >
      </b-tooltip>
    </div>
    <loading v-if="!weights"></loading>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import { GET_WEIGHTS, UPDATE_WEIGHT } from "@/store/actions";

export default {
  name: "weights",
  components: {
    Loading
  },
  data() {
    return {
      tabs: [
        "All",
        "Football",
        "Rugby",
        "Cricket",
        "Tennis",
        "Golf",
        "Motorsport"
      ],
      selectedType: "All"
    };
  },
  computed: {
    weights() {
      return this.$store.state.weights.data
        ? this.$store.state.weights.data
            .filter(x => x.sport !== "Other")
            .sort((a, b) => b.feed_weight - a.feed_weight)
        : null;
    },
    filteredWeights() {
      if (!this.weights) {
        return null;
      }

      if (this.selectedType === "All") {
        return this.weights;
      }

      return this.weights.filter(x => x.sport === this.selectedType);
    }
  },
  watch: {
    weights() {
      for (let i = 0; i < this.weights.length; i++) {
        const weight = this.weights[i];
        const id = `slider-${weight.slug}`;
        if (!document.getElementById(id)) {
          let style = document.createElement("style");
          style.id = id;
          style.type = "text/css";
          style.innerHTML = `
          .${id}::-webkit-slider-thumb {background: url('${
            weight.image_url
          }');} 
          .${id}::-moz-range-thumb {background: url('${weight.image_url}');}`;
          document.body.appendChild(style);
        }
      }
    }
  },
  mounted() {
    if (!this.weights) {
      this.$store.dispatch(GET_WEIGHTS);
    }
  },
  methods: {
    tabChanged(tabName) {
      this.selectedType = tabName;
    },
    weightChanged(item) {
      this.$store.dispatch(UPDATE_WEIGHT, item);
    }
  }
};
</script>

<style scoped>
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 28px;
  height: 28px;
  border: 0;
  background-size: 28px 28px;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 28px;
  height: 28px;
  border: 0;
  background-size: 28px 28px;
  cursor: pointer;
}
</style>
